import CancelIcon from '@mui/icons-material/Cancel';
import MoreIcon from '@mui/icons-material/More';
import { Box, Card, Divider, Typography } from '@mui/material';
import React from 'react';
import { localise } from '../../../../../locale/locale';
import {
  PopupOnOverlayComponent,
  usePopupOnOverlayContext,
} from '../../../../base/overlay/PopupOnOverlay';
import { HelpOverlay } from '../../../../base/tutorial/helpOverlay/HelpOverlay';
import { AnimatedStack } from '../../../../MotionMui/MotionMui';
import {
  MatchViewStatesIndex,
  useMatchViewState,
} from '../matchViewContext/MatchViewContext';
import {
  RoundCurrentCommentaryComponent,
  RoundDescriptionCommentaryComponent,
} from './RoundCommentary';

export const CommentaryComponent = () => {
  const matchViewContext = useMatchViewState();
  const currentRound = matchViewContext.currentRound;
  const { isActivePopup } = usePopupOnOverlayContext();

  //Todo make stack have motion list animations
  return (
    <AnimatedStack
      sx={{
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        width: 'min(95vw,50vh)',
        position: 'relative',
      }}
    >
      <RoundCurrentCommentaryComponent
        key={currentRound.roundId}
        homeTeam={matchViewContext.matchState.homeTeam}
        live={true}
        roundState={currentRound}
        showContest1={
          matchViewContext.matchViewStatesIndex >=
          MatchViewStatesIndex.FIRST_CONTEST_SCORES
        }
        showContest2={
          matchViewContext.matchViewStatesIndex >=
          MatchViewStatesIndex.SECOND_CONTEST_SCORES
        }
        teams={matchViewContext.matchState.teams}
        showResult={
          matchViewContext.matchViewStatesIndex >=
          MatchViewStatesIndex.VICTORS_DISCARD
        }
        additionalChild={colours => <Box
          sx={{
            cursor: 'pointer',
            marginLeft: 'auto',
          }}
        ><PopupOnOverlayComponent
          expandedChildren={(setViewExpandedChildren) => (
            <AllRoundCommentaryComponent
              setViewAll={setViewExpandedChildren}
            />
          )}
        >        <HelpOverlay
          blockSkip={true}
          tutorialId="match.expandCommentary"
          helpText={localise('match.expandCommentary')}
          additionalCondition={currentRound.roundId > 0 && !isActivePopup}
          textHeight="20vh"
        >
              <Box sx={{
                //Not 
                padding: '0.5vmin',
                backgroundColor: colours.primaryBackgroundColour,
                borderRadius: '33%'
              }}>
                <MoreIcon fontSize="large" />
              </Box>
            </HelpOverlay>
          </PopupOnOverlayComponent></Box>}
      />
    </AnimatedStack>
  );
};

const AllRoundCommentaryComponent = ({
  setViewAll,
}: {
  setViewAll: (viewing: boolean) => void;
}) => {
  const matchViewContext = useMatchViewState();
  const currentRound = matchViewContext.currentRound;

  const previousRounds = matchViewContext.matchState.rounds
    .filter((round) => round.roundId < currentRound.roundId)
    .map((round) => (
      <React.Fragment key={round.roundId}>
        <Divider sx={{ width: '100%', my: 2 }}>
          <Typography variant="caption">
            {`Round ${round.roundId + 1}`}
          </Typography>
        </Divider>
        <RoundDescriptionCommentaryComponent
          homeTeam={matchViewContext.matchState.homeTeam}
          live={false}
          roundState={round}
          showContest1={true}
          showContest2={true}
          teams={matchViewContext.matchState.teams}
          showResult={true}
        />
      </React.Fragment>
    ))
    .reverse();

  return (
    <Card
      sx={{
        padding: '2vmin',
        marginTop: '20vh',
        maxHeight: '60vh',
        overflowY: 'scroll',
        backgroundColor: `rgba(255,255,255,0.5)`,
        position: 'relative',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box
        onClick={() => setViewAll(false)}
        sx={{
          position: 'sticky',
          width: '100%',
          top: '1vmin',
          cursor: 'pointer',
          zIndex: 1,
        }}
      >
        <CancelIcon
          sx={{
            position: 'absolute',
            top: '1vmin',
            right: '1vmin',
            cursor: 'pointer',
          }}
        />
      </Box>
      <AnimatedStack
        sx={{
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          width: 'min(95vw,50vh)',
        }}
      >
        <React.Fragment>
          <Divider sx={{ width: '100%', my: 2 }}>
            <Typography variant="caption">
              {`Round ${currentRound.roundId + 1}`}
            </Typography>
          </Divider>
          <RoundDescriptionCommentaryComponent
            homeTeam={matchViewContext.matchState.homeTeam}
            live={
              matchViewContext.matchViewStatesIndex <=
              MatchViewStatesIndex.FINISHED
            }
            roundState={currentRound}
            showContest1={
              matchViewContext.matchViewStatesIndex >=
              MatchViewStatesIndex.FIRST_CONTEST_SCORES
            }
            showContest2={
              matchViewContext.matchViewStatesIndex >=
              MatchViewStatesIndex.SECOND_CONTEST_SCORES
            }
            teams={matchViewContext.matchState.teams}
            showResult={
              matchViewContext.matchViewStatesIndex >=
              MatchViewStatesIndex.VICTORS_DISCARD
            }
          />
        </React.Fragment>
        {previousRounds}
      </AnimatedStack>
    </Card>
  );
};
